<!--
  子账单列表
  lovi 2020-03-04
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar :title="data.title" left-arrow @click-left="navBarBack" />
    <div
      class="scroll-wrapper"
      :class="{ noCrad: !subOrder.length && getListFlag }"
    >
      <div v-if="!subOrder.length && getListFlag" class="noCard-wrap">
        <img src="@/assets/images/public/pic_kong@2x.png" />
        <p class="text-gray">{{ $t("common.noData") }}</p>
      </div>

      <scroll
        ref="scroll"
        v-if="subOrder.length && getListFlag"
        :data="subOrder"
        :pullUpLoad="true"
        :pullDownRefresh="true"
        @pullingDown="pullingDown"
        @pullingUp="pullingUp"
      >
        <!-- 批量话费、批量流量 -->
        <ul class="item-list" v-if="data.type == 20 || data.type == 21">
          <li v-for="(item, index) in subOrder" :key="index">
            <div class="list-l">
              <h3>{{ item.phone }}</h3>
              <p class="text-gray">
                {{ $t("common.transactionTime") }}：{{ item.createtime }}
              </p>
              <p class="text-gray">
                {{ $t("common.orderNumber") }}：{{ item.order_sn }}
              </p>
              <p class="text-gray">
                {{ $t("common.thirdPartyOrderNumber") }}：{{
                  item.third_order_no
                    ? item.third_order_no
                    : $t("common.nothing")
                }}
              </p>
            </div>
            <div class="list-r">
              <h3>
                {{ item.money_type == 1 ? "+" : item.money_type == 2 ? "-" : ""
                }}{{ item.money }}
              </h3>
              <p :class="item.status_key == 1 ? 'text-red' : 'text-blue'">
                {{ item.status }}
              </p>
            </div>
          </li>
        </ul>

        <!-- 批量转账 -->
        <ul class="item-list" v-else>
          <li v-for="(item, index) in subOrder" :key="index">
            <div class="list-l">
              <h3>{{ item.username }}</h3>
              <p class="text-gray">
                {{ $t("common.mobileNumber") }}：{{ item.phone }}
              </p>
              <p class="text-gray">
                {{ $t("common.transactionTime") }}：{{ item.createtime }}
              </p>
              <p class="text-gray">
                {{ $t("common.orderNumber") }}：{{ item.order_sn }}
              </p>
            </div>
            <div class="list-r">
              <h3>
                {{ item.money_type == 1 ? "+" : item.money_type == 2 ? "-" : ""
                }}{{ item.money }}
              </h3>
              <p :class="item.status_key == 1 ? 'text-red' : 'text-blue'">
                {{ item.status }}
              </p>
            </div>
          </li>
        </ul>
      </scroll>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
      page: 1, // 分页
      row: 10, // 每页显示条数
      subOrder: [], // 子订单数据
      getListFlag: false,
      pullUpLoadFlag: false
    };
  },
  created() {
    let vm = this;
    vm._getList();
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:subOrderFlag", false);
    },
    pullingDown() {
      let vm = this;
      vm.page = 1;
      vm._getList();
    },
    pullingUp() {
      let vm = this;
      if (vm.pullUpLoadFlag) {
        vm.$refs.scroll.forceUpdate(false);
        return;
      }
      vm.page += 1;
      vm._getList(1);
    },
    _getList(flag) {
      //获取列表
      let vm = this;
      let params = {};
      params.order_id = vm.data.order_id;
      params.status = vm.data.status;
      params.type = vm.data.type;
      params.page = vm.page;
      params.row = vm.row;
      let loading = true;
      vm.getListFlag = false;
      if (flag) {
        loading = false;
        vm.getListFlag = true;
      }
      vm.rechargeRecordDetailsSub(params, loading);
    },
    rechargeRecordDetailsSub(params, loading) {
      let vm = this;
      vm.$post("/app/recharge/rechargeRecordDetailsSub", params, {
        loading: loading
      }).then(res => {
        console.log("rechargeRecordDetailsSub", res);
        vm.getListFlag = true;
        if (vm.page == 1) {
          vm.subOrder = res.list;
        } else {
          vm.subOrder = vm.subOrder.concat(res.list);
        }
        if (res.list.length < vm.row) {
          vm.pullUpLoadFlag = true;
        } else {
          vm.pullUpLoadFlag = false;
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.item-list {
  padding-left: 15px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px 12px 0;
    line-height: 1;
    border-bottom: 1.1px solid #e4e4e4;
    h3 {
      font-size: 16px;
      font-weight: 500;
    }
    p {
      margin-top: 5px;
    }
    .list-l {
      flex: 1;
    }
    .list-r {
      text-align: right;
    }
  }
}
</style>
